import React from 'react';
import Icon from '../../../components/AppIcon';

const EventStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Events',
      value: stats?.totalEvents,
      icon: 'Calendar',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      change: stats?.eventsChange,
      changeType: stats?.eventsChange >= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Active Events',
      value: stats?.activeEvents,
      icon: 'Radio',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      change: stats?.activeChange,
      changeType: stats?.activeChange >= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Total Revenue',
      value: `$${stats?.totalRevenue?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      change: stats?.revenueChange,
      changeType: stats?.revenueChange >= 0 ? 'positive' : 'negative'
    },
    {
      title: 'Total Attendees',
      value: stats?.totalAttendees?.toLocaleString(),
      icon: 'Users',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      change: stats?.attendeesChange,
      changeType: stats?.attendeesChange >= 0 ? 'positive' : 'negative'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">{stat?.title}</p>
              <p className="text-2xl font-bold text-foreground mt-1">{stat?.value}</p>
              {stat?.change !== undefined && (
                <div className={`flex items-center mt-2 text-sm ${
                  stat?.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                }`}>
                  <Icon 
                    name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                    size={14} 
                    className="mr-1" 
                  />
                  <span>{Math.abs(stat?.change)}%</span>
                  <span className="text-muted-foreground ml-1">vs last month</span>
                </div>
              )}
            </div>
            <div className={`p-3 rounded-lg ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventStats;